import { AxiosInstance, AxiosRequestConfig } from 'axios';

import {
  Distributor,
  DistributorEmployeeLink,
  DistributorEmployeeLinkCreatePayload,
  DistributorEmployeeLinkDeletePayload,
  DistributorEmployeeLinkListPayload,
  DistributorMutation,
  Warehouse,
  WarehouseMutation,
  WarehouseType,
  WarehouseTypeMutation,
  DistributorOutlet,
  DistributorOutletListPayload,
  DistributorOutletMutation,
} from './models/distributor';
import { RequestPayload } from './types';

const LIST_ENDPOINT = 'distributor/list/';
const CREATE_ENDPOINT = 'distributor/create/';
const UPDATE_ENDPOINT = 'distributor/update/';
const DELETE_ENDPOINT = 'distributor/delete/';

const LIST_WAREHOUSES_ENDPOINT = '/distributor/warehouse/list/';
const CREATE_WAREHOUSE_ENDPOINT = '/distributor/warehouse/create/';
const UPDATE_WAREHOUSE_ENDPOINT = '/distributor/warehouse/update/';
const DELETE_WAREHOUSE_ENDPOINT = '/distributor/warehouse/delete/';

const LIST_WAREHOUSE_TYPES_ENDPOINT = '/distributor/warehouse_type/list/';
const CREATE_WAREHOUSE_TYPE_ENDPOINT = '/distributor/warehouse_type/create/';
const UPDATE_WAREHOUSE_TYPE_ENDPOINT = '/distributor/warehouse_type/update/';
const DELETE_WAREHOUSE_TYPE_ENDPOINT = '/distributor/warehouse_type/delete/';

const OUTLET_LIST_ENDPOINT = 'distributor/outlet/list/';
const OUTLET_CREATE_ENDPOINT = 'distributor/outlet/create/';
const OUTLET_UPDATE_ENDPOINT = 'distributor/outlet/update/';

const EMPLOYEE_LINK_LIST_ENDPOINT = 'distributor/employee_link/list/';
const EMPLOYEE_LINK_CREATE_ENDPOINT = 'distributor/employee_link/create/';
const EMPLOYEE_LINK_DELETE_ENDPOINT = 'distributor/employee_link/delete/';

// eslint-disable-next-line import/no-anonymous-default-export
export default (instance: AxiosInstance, config: AxiosRequestConfig) => ({
  getDistributors: (payload: RequestPayload) =>
    instance.post<ApiResponse<Paginated<'data', Distributor>>>(LIST_ENDPOINT, payload, config),
  createDistributor: (payload: DistributorMutation) =>
    instance.post<ApiResponse<Distributor>>(CREATE_ENDPOINT, payload, config),
  updateDistributor: (payload: DistributorMutation) =>
    instance.put<ApiResponse<Distributor>>(UPDATE_ENDPOINT, payload, config),
  deleteDistributor: (payload: { id: number; is_active: boolean }) =>
    instance.post<ApiResponse<any>>(DELETE_ENDPOINT, payload, config),
  getWarehouses: () =>
    instance.get<ApiResponse<Warehouse[]>>(LIST_WAREHOUSES_ENDPOINT, config),
  createWarehouse: (payload: WarehouseMutation) =>
    instance.post<ApiResponse<Warehouse>>(CREATE_WAREHOUSE_ENDPOINT, payload, config),
  updateWarehouse: (payload: WarehouseMutation) =>
    instance.put<ApiResponse<Warehouse>>(UPDATE_WAREHOUSE_ENDPOINT, payload, config),
  deleteWarehouse: (id: number) =>
    instance.post<ApiResponse<Warehouse>>(DELETE_WAREHOUSE_ENDPOINT, { ...config, data: { id }, headers: { ...config.headers, 'cache-force': true } }),
  getWarehouseTypes: () =>
    instance.get<ApiResponse<WarehouseType[]>>(LIST_WAREHOUSE_TYPES_ENDPOINT, { ...config, headers: { ...config.headers, 'cache-force': true } }),
  createWarehouseType: (payload: WarehouseTypeMutation) =>
    instance.post<ApiResponse<WarehouseType>>(CREATE_WAREHOUSE_TYPE_ENDPOINT, payload, config),
  updateWarehouseType: (payload: WarehouseTypeMutation) =>
    instance.put<ApiResponse<WarehouseType>>(UPDATE_WAREHOUSE_TYPE_ENDPOINT, payload, config),
  deleteWarehouseType: (id: number) =>
    instance.post<ApiResponse<WarehouseType>>(DELETE_WAREHOUSE_TYPE_ENDPOINT, { ...config, data: { id } }),

  getEmployeeLinks: (payload: DistributorEmployeeLinkListPayload) =>
    instance.post<ApiResponse<DistributorEmployeeLink[]>>(EMPLOYEE_LINK_LIST_ENDPOINT, payload, config),
  createEmployeeLink: (payload: DistributorEmployeeLinkCreatePayload) =>
    instance.post<ApiResponse<{ id: number }>>(EMPLOYEE_LINK_CREATE_ENDPOINT, payload, config),
  deleteEmployeeLink: (payload: DistributorEmployeeLinkDeletePayload) =>
    instance.post<ApiResponse<Record<string, never>>>(EMPLOYEE_LINK_DELETE_ENDPOINT, payload, config),

  getDistributorOutlets: (payload: DistributorOutletListPayload) =>
    instance.post<ApiResponse<Paginated<'data', DistributorOutlet>>>(OUTLET_LIST_ENDPOINT, payload, config),
  createDistributorOutlet: (payload: DistributorOutletMutation) =>
    instance.post<ApiResponse<{ id: number }>>(OUTLET_CREATE_ENDPOINT, payload, config),
  updateDistributorOutlet: (payload: DistributorOutletMutation) =>
    instance.post<ApiResponse<{ id: number }>>(OUTLET_UPDATE_ENDPOINT, payload, config),
});
